export default "<div class=\"bi\" id=\"pbi-report\" #powerBIReports></div>\n";